import debounce from 'lodash/debounce'
import * as aTypes from '../action-types'
import * as mTypes from '../mutation-types'
import api from '../../api'
import { mapContactItem, mapCfItem, mapFormItem } from '../../utils'

/*
const sampleResult = {
  contacts: [
    {
      avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
      name: '王小华',
      phone: '12312341234'
    }, {
      avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
      name: '王小华',
      phone: '12312341234'
    }, {
      avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
      name: '王小华',
      phone: '12312341234'
    }
  ],
  orgs: [
    {
      name: '某科学机构'
    },
    {
      name: '某魔法机构'
    },
    {
      name: '某宗教机构'
    }
  ],
  cfs: [
    {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名',
      value: 346844.12,
      update: '今天 16:50'
    }, {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名',
      value: 346844.12,
      update: '今天 16:50'
    }, {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名羊宝宝和小兔兔的展览报名',
      value: 346844,
      update: '今天 16:50'
    }
  ],
  forms: [
    {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名',
      value: 111,
      update: '今天 16:50'
    }, {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名',
      value: 456,
      update: '今天 16:50'
    }, {
      id: 'something',
      name: '羊宝宝和小兔兔的展览报名羊宝宝和小兔兔的展览报名',
      value: 789,
      update: '今天 16:50'
    }
  ],
  activities: [
    {
      'id': 'caqox9g48omp21rydmpdvew7n5qkz3lm',
      'title': '哈哈哈哈',
      'signed_up_user_count': 4
    }
  ]
}
*/

const debouncedSearch = debounce(api.search.search, 300)

const state = {
  showResult: false,
  showEmpty: false,

  result: {
    contacts: [],
    orgs: [],
    cfs: [],
    forms: [],
    activities: []
  }
}

const actions = {
  [aTypes.SEARCH] ({ commit, dispatch }, value) {
    commit(mTypes.SET_LOADING, { key: aTypes.SEARCH, loading: true })
    // dispatch(aTypes.ZHUGE_TRACK, { event: '用搜索功能' })
    debouncedSearch({
      success (res) {
        const body = res.body
        const result = {
          contacts: body.contacts.map(mapContactItem),
          forms: body.forms.map(mapFormItem),
          orgs: body.orgs.map(o => {
            return {
              id: o.id,
              name: o.name
            }
          }),
          cfs: body.projects.map(mapCfItem),
          activities: body.activities || []
        }
        commit(mTypes.SET_SEARCH_RESULT, result)
        commit(mTypes.SET_LOADING, { key: aTypes.SEARCH, loading: false })
      },
      commit
    }, value)
  }
}

const mutations = {
  [mTypes.SET_SEARCH_RESULT] (state, result) {
    const empty = !result || (
      (!result.contacts || result.contacts.length <= 0) &&
      (!result.orgs || result.orgs.length <= 0) &&
      (!result.cfs || result.cfs.length <= 0) &&
      (!result.forms || result.forms.length <= 0) &&
      (!result.activities || result.activities.length <= 0)
    )
    if (empty) {
      state.showResult = false
      state.showEmpty = true
    } else {
      state.result = result
      state.showResult = true
      state.showEmpty = false
    }
  },
  [mTypes.CLEAR_SEARCH_RESULT] (state) {
    state.showResult = false
    state.showEmpty = false
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js